import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol viewBox=\"0 0 34 34\" id=\"user\">\n    <defs>\n        <circle id=\"user_a\" cx=\"17\" cy=\"17\" r=\"17\" />\n    </defs>\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <mask id=\"user_b\" fill=\"#fff\">\n            <use xlink:href=\"#user_a\" />\n        </mask>\n        <use fill=\"#FFF\" xlink:href=\"#user_a\" />\n        <circle cx=\"17\" cy=\"15\" r=\"5\" fill=\"#BFC5D2\" mask=\"url(#user_b)\" />\n        <circle cx=\"17\" cy=\"34\" r=\"12\" fill=\"#BFC5D2\" mask=\"url(#user_b)\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svgs/user.svg
// module id = 164
// module chunks = 0